import { Routes, Route } from "react-router-dom";
import Kyc from "./pages/Kyc/Kyc";
import Layout from "./components/Layout/Layout";
import AccValidation from "./pages/AccValidation/AccValidation";
import KycPreview from "./pages/KycPreview/KycPreview";
import Login from "./pages/Login/Login";
import { PrivateRoute } from "./components/PrivateRoute/PrivateRoute";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      
      <Route element={<PrivateRoute />}>
        <Route path="/content" element={<Layout />}>
          <Route path="kyc" element={<Kyc />} />
          <Route path="kyc/:companyId/:entityType" element={<KycPreview />} />
          <Route path="acc-validation" element={<AccValidation />} />
        </Route>
      </Route>
    </Routes>
  );
}
export default App;
